import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import { Image, RES } from 'models/Image';
import { ResponsiveCarousel } from '../ResponsiveCarousel/ResponsiveCarousel';
import { VenueListItem } from '../VenueListItem/VenueListItem';

export const VenueCarousel = ({ elements, header, loading, nolink, type, showCount }) => (
  <ResponsiveCarousel
    extraClass={classNames('carousel--venues', { [`carousel--venues-${type}`]: type })}
    header={header}
    loading={loading}
    type={type}>
    {(elements || []).slice(0, 20).map(item => (
      <VenueListItem
        type={type}
        key={item.id}
        venueId={item.id}
        activities={item.activities}
        imageUrl={Image.getImage(item.images, RES.low) || ''}
        name={item.name}
        subtitle={item.subtitle}
        hood={(item.location && item.location.name) || ''}
        alias={item.alias}
        rating={item.ratings && item.ratings.mean > 0 ? item.ratings.mean : -1}
        nolink={nolink}
        showRatingNumber={!showCount}
        count={showCount && `${item.ratings.display_total} ratings`}
      />
    ))}
  </ResponsiveCarousel>
);

VenueCarousel.propTypes = {
  elements: PropTypes.array,
  header: PropTypes.string,
  loading: PropTypes.bool,
  nolink: PropTypes.bool,
  type: PropTypes.string,
  showCount: PropTypes.bool,
};
